module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r9n2r5n-c5c836fcad715099f40e39a4b16c40b5.svg";